import { create } from 'zustand'
import type { IPropertyDetail } from '../../../interfaces/src'

interface ModalShareFileV2State {
  modalShareFileV2: {
    isOpen: boolean
    property?: IPropertyDetail | null
    propertyId?: string | null
    enableCallViewService?: boolean
  }
  showModalPDF: boolean
  setShowModalPDF: (showModalPDF: boolean) => void
  setModalShareFileV2: (modalShareFileV2: {
    isOpen: boolean
    property?: IPropertyDetail | null
    propertyId?: string | null
    enableCallViewService?: boolean
  }) => void
  reset: () => void
}

const initialState = {
  modalShareFileV2: {
    isOpen: false,
    property: null,
    propertyId: null,
    enableCallViewService: false
  },
  showModalPDF: false
}

export const useModalShareFileV2Store = create<ModalShareFileV2State>()(
  (set) => ({
    ...initialState,
    setModalShareFileV2: (modalShareFileV2) => set({ modalShareFileV2 }),
    setShowModalPDF: (showModalPDF) => set({ showModalPDF }),
    reset: () =>
      set({
        modalShareFileV2: initialState.modalShareFileV2
      })
  })
)
